import type { IDefaultCommitteeResult } from '__generated__';
import { baseApi } from 'store/api';
import { APIRead, normalizeError } from 'utils/api-client';

export const ratingProcessHelperApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDefaultCommittee: builder.query<IDefaultCommitteeResult, { companyId: number }>({
      async queryFn({ companyId }) {
        try {
          const { data } = await APIRead.api.ratingProcessHelperGetDefaultCommitteeDetail({
            companyId,
          });
          return { data };
        } catch (error) {
          return { error: normalizeError(error) };
        }
      },
    }),
  }),
});

export const { useLazyGetDefaultCommitteeQuery } = ratingProcessHelperApi;
